import React from 'react';
const frictions = ['Vous voulez organiser une action Octobre Rose qui ait du sens, mais vous manquez de temps pour tout créer vous-même.', 'Vous cherchez des idées, téléchargez quelques ressources, assemblez différents supports…', 'Et au final, vous vous retrouvez avec des documents dispersés qui ne forment pas réellement une animation.'];
export function Problem() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-122" data-mp="21peelv8h2r4v">
      <div className="mx-auto w-full max-w-3xl px-5 text-center md:px-8" data-id="element-123" data-mp="21ntja3ec345y">
        <p className="text-xs font-extrabold uppercase tracking-widest text-pink-700" data-id="element-124" data-mp="26hek037bac8u">
          Le problème
        </p>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-neutral-800 md:text-5xl" data-id="element-125" data-mp="1sr2nzt7lvtcf">
          Vous avez l’envie.{' '}
          <span className="bg-pink-200 px-1.5 pb-0.5 text-pink-950" data-id="element-126" data-mp="1iqin4ro00quq">
            Il vous manque les bons supports.
          </span>
        </h2>

        <ul className="mt-11 space-y-4 text-left" data-id="element-127" data-mp="1npdcydkdvfoc">
          {frictions.map(item => <li key={item} className="flex items-start gap-4 border-l-4 border-amber-300 bg-stone-50 px-5 py-4 text-lg text-neutral-600 md:px-6 md:text-xl" data-id="element-128" data-mp="t8do7lfgi73p">
              {item}
            </li>)}
        </ul>

        <p className="mt-11 text-2xl font-extrabold leading-snug tracking-tight text-neutral-800 md:text-3xl" data-id="element-129" data-mp="xb0li1uwck8a">
          Un simple dépliant informe. Une animation bien pensée peut, elle, ouvrir le dialogue,
          faire réfléchir et créer un véritable moment de partage.
        </p>
        <p className="mt-4 text-lg text-neutral-500" data-id="element-130" data-mp="jbhcl6u9h4ux">
          Octobre approche. Vous n’avez pas besoin de repartir de zéro.
        </p>
      </div>
    </section>;
}